<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">账户设置</a></li>
                <li><a href="#">充值信息</a></li>
            </ul>
        </div>

        <div class="formbody">
            <div class="formtitle"><span>充值信息</span></div>
            <div id="usual1" class="usual"> 
                <div id="tab1" class="tabson">                
                    <table class="tablelist">
                        <thead>
                            <tr>								
                                <th>充值金额</th>
                                <th>赠送金额</th>
                                <th>充值时间</th>
                                <th>充值方式</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(item, index) in list" :class="{odd:index%2!=0}">
                                <td>{{item.money}}</td>
                                <td>{{item.giftMoney}}</td>
                                <td>
                                    {{item.createtime.split('.')[0]}}
                                </td>
                                <td>
                                    <template v-if="item.paytype == 'wissip'">
                                        多讯代理用户充值
                                    </template>
                                    <template v-else-if="item.paytype == 'alipay'">
                                        用户自己充值
                                    </template>
                                    <template v-else-if="item.paytype == 'admin'">
                                        客服手动充值
                                    </template>
                                    <template v-else-if="item.paytype == 'choujiang'">
                                        抽奖充值
                                    </template>
                                    <template v-else-if="item.paytype == 'yhjcz'">
                                        优惠卷抽奖充值
                                    </template>
                                    <template v-else-if="item.paytype == 'receive'">
                                        活动领取
                                    </template>
                                </td>
                            </tr>     
                        </tbody>
                    </table>

                    <div class="pagin">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pageIndex"
                            :page-sizes="[pageSize]"
                            :page-size="50"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalCount">
                        </el-pagination>
                    </div>

                    <!-- 查询等待 -->
                    <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
                        top: 0; left: 0;display: block;" v-show="loadingShow"></div>
                    <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
                        -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
                        <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
                        <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    data() {
        return {
            list: [],
            pageIndex: 1,
            pageSize: 50,
            totalCount: 0,
            loadingShow: true,
        }
    },
    components : {
        'v-cookie' : cookie,
    },
    mounted() {
        this.pageChange(1)
    },
    methods: {
        handleSizeChange(val) {
            this.pageChange(val)
        },
        handleCurrentChange(val) {
            this.pageChange(val)
        },
        pageChange(pageIndex) {
            this.loadingShow = true;
            var that = this
            let param = {'pageIndex': pageIndex, 'pageSize': this.pageSize}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/person/chargeinfo.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if(res.data.code == '0000000')
                {
                    that.list = res.data.xpaysuccessList;
                    that.pageIndex = res.data.page.pageIndex;
                    that.pageSize = res.data.page.pageSize;
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else
                {
                    alert(res.data.msg)
                    return false;
                }
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/person/chargeinfo.vue